import React from 'react';
import { Link } from 'react-router-dom';
import heroImage from '../../assets/images/drawing.png';

const HeroSection: React.FC = () => {
  return (
    <section className="relative bg-primary/5 overflow-hidden">
      {/* Hero Image */}
      <div className="absolute inset-0 z-0">
        <div className="w-full h-full bg-gradient-to-r from-primary/5 via-primary/10 to-primary/5">
          <img 
            src={heroImage} 
            alt="Yeremian Lifestyle Homes - Custom Home Design"
            className="w-full h-full object-cover"
            style={{ opacity: 0.95 }}
          />
        </div>
      </div>
      
      <div className="container-custom relative z-10 py-20 md:py-28 lg:py-36">
        <div className="max-w-3xl backdrop-blur-sm bg-white/40 p-8 rounded-lg shadow-lg">
          <h1 className="text-dark mb-6">
            <span className="block font-serif">Building Your</span>
            <span className="text-secondary font-bold">Dream Home</span>
          </h1>
          <p className="text-lg md:text-xl text-gray-800 mb-8 max-w-2xl">
            Yeremian Lifestyle Homes creates beautiful, quality custom homes throughout Georgia with craftsmanship and attention to detail.
          </p>
          <div className="flex flex-wrap gap-4">
            <Link 
              to="/homes" 
              className="btn bg-primary hover:bg-primary/90 text-white font-semibold shadow-md hover:shadow-lg transition-all"
            >
              Explore Our Homes
            </Link>
            <Link 
              to="/neighborhoods" 
              className="btn bg-secondary text-white hover:bg-secondary/90 shadow-md hover:shadow-lg transition-all"
            >
              Find a Neighborhood
            </Link>
          </div>
        </div>
      </div>

      {/* Design Element: Diagonal Cut */}
      <div className="absolute bottom-0 left-0 right-0 h-16 bg-white transform -skew-y-2 translate-y-8 z-10"></div>
    </section>
  );
};

export default HeroSection; 